import type { SplunkInstaller } from "./types";

export const splunkInstaller: SplunkInstaller = {
  components: {
    "audit-log": {
      items: {
        endpoint: {
          labeler: () => "Splunk HEC endpoint",
        },
        token: {
          labeler: () => "HEC token",
        },
        index: {},
      },
    },
  },
};
